import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/mocks/movies";

interface LatestGridProps {
  movies: Movie[];
}

export default function LatestGrid({ movies }: LatestGridProps) {
  return (
    <section className="w-full bg-background-100" aria-label="最新内容推荐">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="font-label text-sm font-medium text-accent-600">精选片单</p>
            <h2 className="mt-1.5 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新内容推荐
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              与《出轨的妻子》同类型的高清影视作品，涵盖剧情、爱情与悬疑题材，方便影迷延伸探索。
            </p>
          </div>
          <Link
            to="/category"
            className="hidden whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer md:inline-flex md:items-center md:gap-1"
          >
            查看更多
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-8 flex justify-center md:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            查看全部电影
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}